'use client'
import React from 'react'
import { useConfig } from 'hooks'
import device from 'sw-modules/device'

import { PageHeading } from 'components'

import VaultsTabs from './VaultsTabs/VaultsTabs'
import VaultsExplainedButton from './VaultsExplainedButton/VaultsExplainedButton'

import messages from './messages'


const VaultsView: React.FC = () => {
  const { sdk } = useConfig()
  const { isMobile } = device.useData()

  const description = {
    ...messages.description,
    values: {
      mintToken: sdk.config.tokens.mintToken,
      depositToken: sdk.config.tokens.depositToken,
    },
  }

  return (
    <div className="width-container">
      <PageHeading
        className={isMobile ? 'mt-32' : 'mt-60'}
        title={messages.title}
        description={description}
      />
      <VaultsExplainedButton className="mt-32" />
      <VaultsTabs className="pb-24" />
    </div>
  )
}


export default React.memo(VaultsView)
